module.exports = __webpack_public_path__ + "media/img/covers/auth-side-cover-15570f310c488ca660e833077c867a7c.jpg";